import { z } from "zod";
/** Staff compose: promote a working document, then attach the Vault copy. */
export const SubjectPromoteAndAttachSchema = z.object({
    workspaceDocumentId: z.string().uuid(),
    vaultFolderId: z.string().uuid(),
    renderAsPdf: z.boolean().optional(),
});
export const SubjectPromoteAndAttachResultSchema = z.object({
    workspaceDocumentId: z.string(),
    vaultDocumentId: z.string(),
    attached: z.boolean(),
    reusedExistingPromotion: z.boolean(),
    attachError: z.string().nullable(),
});
//# sourceMappingURL=subject-evidence-intake.js.map